import React from 'react'
import {
  Overlay,
  ModalContent,
  CloseButton
} from './BookingModal.style'

const BookingModal = ({ open, onClose }) => {
  if (!open) return null
  return (
    <Overlay open={open}>
      <ModalContent>
        <CloseButton onClick={onClose}>X</CloseButton>
        <iframe
          src="https://api.leadconnectorhq.com/widget/booking/5yVHyzE5gSXMfjEhEAwH"
          style={{ width: '100%', height: '100%', border: 'none', overflow: 'hidden' }}
          scrolling="yes"
          id="5yVHyzE5gSXMfjEhEAwH_1749488976027"
        ></iframe>
      </ModalContent>
    </Overlay>
  )
}

export default BookingModal